import React from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import TablePagination from '@mui/material/TablePagination';
import FilterListIcon from '@mui/icons-material/FilterList';
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import TableRow from '@mui/material/TableRow';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Menu from '@mui/material/Menu';
import Box from '@mui/material/Box';

import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { LoadButtons } from '../components/LoadButtons';
import { LoadButtonHeaderTable } from '../../../components/sharedViews/loadActionsHeader/LoadButtonHeaderTable';
import { FilterTable } from '../../../components/others/FilterTable';
import identificationTypes from "../../../data/identificationTypes.json";
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { useManageSharedViews } from '../hooks/useManageSharedViews';
import { TruncateText } from '../../../components/others/TruncateText';
import ItemFieldDisplay from '../components/ItemFieldDisplay';
import { getFieldContent } from '../../../utils/formatters';
import { CacheProvider } from '../../../context/CacheContext';

const EMPTY = () => {
    const { t } = useTranslation();
    return <Typography textAlign="center" py={6}>{t('messages.noRecords')}</Typography>
};

const LOADING = () => (
    <Box sx={{ textAlign: 'center', py: 6 }}>
        <CircularProgress />
    </Box>
);

export const LayoutSharedViews = ({ config = null }) => {
    const {
        isMobileScreen,
        DocManager,
        configuration,
        buttons,
        columns,
        id_user_action,
        companies,
        openDialogCompany,
        expandedId,
        anchorEl,
        //REDUX DATA
        listAllDocs,
        isLoading,
        rowsChecked,
        filters,
        pagination,
        counter,
        //REDUX DATA
        // custom functions
        t,
        setAnchorEl,
        handleConfirmAction,
        handleChangePage,
        handleChangeRowsPerPage,
        Search,
        ResetSearch,
        RefreshTable,
        handleCheckAll,
        handleCheck,
        handleLoadMore,
        isCheck,
        Cancel,
        handleExpandedId
        // custom functions
    } = useManageSharedViews(config);
    
    console.log("LayoutSharedViews -> listAllDocs: ", listAllDocs);

    return (
        <CacheProvider>
            <Box sx={{ width: '100%' }} className='custom-hard-table-zd-nix'>
                <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                    <Box
                        className="box-container-actions-header"
                        sx={{
                            flexDirection: isMobileScreen ? 'column' : 'row',
                            alignItems: isMobileScreen ? 'flex-start' : 'center'
                        }}
                    >
                        <Box>
                            <Typography sx={{
                                color: (theme) => theme.palette.text.primary,
                                fontWeight: 'bold',
                                fontSize: isMobileScreen ? "17px" : "20px"
                            }}>
                                {configuration?.title || 'Consultar documentos'}
                            </Typography>
                            {configuration?.description &&
                                < Typography sx={{
                                    color: (theme) => theme.palette.text.primary,
                                    fontSize: isMobileScreen ? "11px" : "14px"
                                }}>
                                    {configuration.description}
                                </Typography>
                            }
                        </Box>

                        <Box className="box-actions-header"
                            sx={{
                                flexWrap: isMobileScreen ? 'wrap' : 'nowrap',
                                width: isMobileScreen ? '100%' : 'auto'
                            }}
                        >
                            {isMobileScreen && (
                                <>
                                    <IconButton color="primary"
                                        onClick={(e) => setAnchorEl(e.currentTarget)}
                                    >
                                        <FilterListIcon />
                                    </IconButton>
                                    <Menu PaperProps={{ sx: { minWidth: 220, p: 1 } }}
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={() => setAnchorEl(null)}
                                    >
                                        <Typography variant="subtitle2" className="typographyFilters">
                                            {t('filters')}
                                        </Typography>

                                        {columns.filter(col => col.filterable).map((col, idx) => (
                                            <MenuItem key={idx} className="menuItemLanguage">
                                                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                                                    {col.label}
                                                </Typography>
                                                <FilterTable colum={col} Search={Search} ResetSearch={ResetSearch} filter={filters.hasOwnProperty(col.id)} />
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </>
                            )}

                            <LoadButtonHeaderTable
                                buttons={buttons}
                                id_user_action={id_user_action}
                                DocManager={DocManager}
                                columns={columns}
                                handleChange={RefreshTable}
                            />
                        </Box>
                    </Box>

                    {/* MOBILE VIEW */}
                    {isMobileScreen ? (
                        <Box className="mobileListContainer">
                            {isLoading ? (<LOADING />) : listAllDocs.length === 0 ? (<EMPTY />) : (
                                listAllDocs.map((item) => (
                                    <Paper
                                        key={item.id}
                                        className="paper-item"
                                        isChecked={isCheck(item.id)}
                                        sx={(theme) => ({
                                            backgroundColor: isCheck(item.id)
                                                ? `${theme.palette.primary.main}14`
                                                : theme.palette.paper.background,
                                            border: isCheck(item.id)
                                                ? `1px solid ${theme.palette.primary.main}44`
                                                : "1px solid transparent"
                                        })}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Box className="item-flex-container">
                                                <Box className="checkboxWrapper">
                                                    <Checkbox
                                                        checked={isCheck(item.id)}
                                                        className="customCheckbox"
                                                        onChange={() => handleCheck(item.id)}
                                                        icon={<RadioButtonUncheckedIcon fontSize="medium" />}
                                                        checkedIcon={<CheckCircleIcon fontSize="medium" />}
                                                    />
                                                </Box>
                                                <ItemFieldDisplay
                                                    isExpanded={expandedId === item.id}
                                                    columns={columns}
                                                    item={item}
                                                />
                                            </Box>
                                            <Box className="loadButtonsWrapper">
                                                <LoadButtons data={item} handleChange={RefreshTable} DocManager={DocManager} isMobileScreen={isMobileScreen} />
                                            </Box>
                                        </Box>
                                        <Box sx={{ textAlign: 'center', marginBottom: -2 }}>
                                            <IconButton
                                                onClick={() => handleExpandedId(item.id)}
                                                size="small"
                                                sx={{
                                                    background: '#e2e2e2',
                                                    borderRadius: '50%',
                                                }}
                                            >
                                                {expandedId === item.id ?
                                                    <KeyboardArrowUpIcon fontSize="medium" color='primary' />
                                                    :
                                                    <KeyboardArrowDownIcon fontSize="medium" color='primary' />
                                                }
                                            </IconButton>
                                        </Box>
                                    </Paper>
                                ))
                            )}

                            {(!isLoading && listAllDocs.length < counter) && (
                                <Box sx={{ textAlign: 'center', mt: 2 }}>
                                    <Typography variant="button" className="loadMoreButton" onClick={handleLoadMore}>
                                        {t('loadMore')}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    ) : (
                        <Box sx={{ width: '100%' }}>
                            <Paper
                                sx={{ width: '100%' }}
                                elevation={3}
                            >
                                <TableContainer
                                    style={{ height: '70vh', overflow: 'auto', borderBottom: 'solid 1px' }}
                                >
                                    <Table
                                        aria-labelledby='tableTitle'
                                        size='small'
                                        stickyHeader
                                    >
                                        <TableHead>
                                            <TableRow sx={{ height: '30px' }}>
                                                <TableCell
                                                    align='center'
                                                    sx={{
                                                        minWidth: 40,
                                                        maxWidth: 60,
                                                        position: 'sticky',
                                                        zIndex: 1000,
                                                        left: 0,
                                                        height: 'inherit'
                                                    }}
                                                    id='TcellCheck'
                                                >
                                                    <Checkbox
                                                        checked={listAllDocs.length > 0 && rowsChecked.length === listAllDocs.length}
                                                        onChange={handleCheckAll}
                                                        icon={<RadioButtonUncheckedIcon fontSize="medium" />}
                                                        checkedIcon={<CheckCircleIcon fontSize="medium" />}
                                                        sx={{
                                                            paddingY: '4px',
                                                            "&.Mui-checked": {
                                                                transform: "scale(1.1)",
                                                                transition: "transform 0.2s ease",
                                                            },
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    id={`TcellCheck_actions`}
                                                    padding='normal'
                                                    align='center'
                                                    sx={{ minWidth: 120, position: 'sticky', left: 52, zIndex: 1000, top: '0px', paddingY: '4px' }}
                                                >
                                                    <Typography sx={{ fontWeight: 'bold' }} component='span'>
                                                        {configuration?.actions_label || t('actions')}
                                                    </Typography>
                                                </TableCell>
                                                {
                                                    columns.map((col, index) => (
                                                        col.visible &&
                                                        <TableCell
                                                            padding='normal'
                                                            align='center'
                                                            key={`tc-${index}`}
                                                            sx={{
                                                                width: col?.width ? `${col?.width}px` : "auto",
                                                                minWidth: col?.width ? `${col?.width}px` : "auto",
                                                                maxWidth: col?.width ? `${col?.width}px` : "auto",
                                                                paddingY: '4px'
                                                            }}
                                                        >
                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <Typography sx={{ fontWeight: 'bold', marginRight: '8px' }} component='span'>
                                                                    {col.label}
                                                                </Typography>
                                                                {col.filterable && (
                                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                        <FilterTable colum={col} Search={Search} ResetSearch={ResetSearch} filter={filters.hasOwnProperty(col.id)} />
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                    ))
                                                }
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {isLoading ? (
                                                <TableRow sx={{ height: 200, py: 2 }}>
                                                    <TableCell colSpan={columns.length + 2} align='center'>
                                                        <LOADING />
                                                    </TableCell>
                                                </TableRow>
                                            ) : !isLoading && !listAllDocs.length > 0 ? (
                                                <TableRow sx={{ height: 200, py: 2 }}>
                                                    <TableCell colSpan={columns.length + 2} align='center'>
                                                        <EMPTY />
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                listAllDocs.map((item) => (
                                                    <TableRow tabIndex={-1} key={item.id}>
                                                        <TableCell
                                                            id={`TcellCheck${item.id}`}
                                                            align='center'
                                                            sx={{ position: 'sticky', left: 0, backgroundColor: 'white' }}
                                                        >
                                                            <Checkbox
                                                                key={item.id}
                                                                checked={isCheck(item.id)}
                                                                onChange={() => handleCheck(item.id)}
                                                                icon={<RadioButtonUncheckedIcon fontSize="medium" />}
                                                                checkedIcon={<CheckCircleIcon fontSize="medium" />}
                                                                sx={{
                                                                    "&.Mui-checked": {
                                                                        transform: "scale(1.1)",
                                                                        transition: "transform 0.2s ease",
                                                                    },
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell
                                                            padding='normal'
                                                            align='center'
                                                            sx={{ position: 'sticky', left: 52, backgroundColor: 'white' }}
                                                        >
                                                            <Typography>
                                                                <LoadButtons data={item} handleChange={RefreshTable} DocManager={DocManager} isMobileScreen={isMobileScreen} />
                                                            </Typography>
                                                        </TableCell>
                                                        {
                                                            columns.filter(col => col.visible)
                                                                .map((col, index) => {
                                                                    const content = getFieldContent(col, item, identificationTypes);
                                                                    return (
                                                                        <TableCell
                                                                            key={`tc-${index}${item.id}`}
                                                                            padding='normal'
                                                                            align={col?.align || 'center'}
                                                                        >
                                                                            {col?.truncate ?
                                                                                <TruncateText text={String(content)} limit={col.truncate} />
                                                                                :
                                                                                <Typography sx={{ color: '#858999 !important;' }}>{content}</Typography>
                                                                            }
                                                                        </TableCell>
                                                                    );
                                                                })
                                                        }
                                                    </TableRow>
                                                ))
                                            )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    sx={{
                                        "& .MuiIconButton-root": {
                                            color: "#6728AF",
                                        },
                                        "& .MuiIconButton-root.Mui-disabled": {
                                            color: "rgba(0, 0, 0, 0.26)",
                                        },
                                        ".css-mmygx2-MuiSelect-select-MuiInputBase-input.css-mmygx2-MuiSelect-select-MuiInputBase-input": {
                                            color: "#6728AF",
                                        },
                                        display: 'table-row',
                                        verticalAlign: 'bottom',
                                    }}
                                    rowsPerPageOptions={[25, 50, 100, 250]}
                                    component='Box'
                                    count={counter}
                                    rowsPerPage={pagination.pageSize}
                                    page={pagination.pageNumber - 1}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage={'Filas por pagina'}
                                    labelDisplayedRows={({ from, to, count }) =>
                                        `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`
                                    }
                                />
                            </Paper>
                        </Box>
                    )}
                </Box>

                {
                    openDialogCompany && (
                        <DialogSelectCompany
                            openDialogConfirm={openDialogCompany}
                            handleCancelConfirm={Cancel}
                            handleConfirmAction={handleConfirmAction}
                            data={companies}
                        />
                    )
                }
            </Box >
        </CacheProvider>
    )
}